import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getSeo, OG_IMAGE } from "@/data/seo";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.rel = "canonical";
    document.head.appendChild(el);
  }
  el.href = href;
};

const setPageSchema = (schemas) => {
  document.getElementById("page-jsonld")?.remove();
  if (!schemas.length) return;
  const el = document.createElement("script");
  el.type = "application/ld+json";
  el.id = "page-jsonld";
  el.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": schemas });
  document.head.appendChild(el);
};

export const SeoManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = getSeo(pathname);
    document.title = seo.title;
    setMeta("name", "description", seo.description);
    setMeta("name", "robots", seo.noindex ? "noindex, follow" : "index, follow, max-image-preview:large");
    setMeta("property", "og:title", seo.title);
    setMeta("property", "og:description", seo.description);
    setMeta("property", "og:url", seo.url);
    setMeta("property", "og:image", OG_IMAGE);
    setMeta("name", "twitter:title", seo.title);
    setMeta("name", "twitter:description", seo.description);
    setMeta("name", "twitter:image", OG_IMAGE);
    setCanonical(seo.url);
    setPageSchema(seo.schemas);
  }, [pathname]);

  return null;
};
